import axiosConfig from "./axiosConfig";

const setupAPI = {};

// How far the signed-in person has got with the "getting started" checklist.
setupAPI.get = () => axiosConfig.get("/api/users/setup/").then((res) => res.data);

// Tells the server something it can't see for itself: "installed",
// "opened_event", or the card's own "setup_dismissed" / "setup_celebrated".
setupAPI.milestone = (key) => axiosConfig.post("/api/users/milestone/", { key });

export default setupAPI;
